import { DeviceGalleryQuery$data } from '__generated__/DeviceGalleryQuery.graphql';
import { MetaTagsProps } from 'shared/components/MetaTags';

export interface DeviceGalleryMeta {
  deviceGallery: DeviceGalleryQuery$data['deviceGallery'];
  segment: MetaTagsProps['segment'];
  categoryId: string;
}

export function formatDeviceGalleryMeta({
  deviceGallery,
  segment,
  categoryId,
}: DeviceGalleryMeta): MetaTagsProps {
  const selectedSubcategory = deviceGallery.subcategories.find(
    (subcategory) => subcategory.categoryId === categoryId,
  );
  const name = selectedSubcategory?.name;
  return {
    slug: categoryId,
    title: name,
    description: name,
    segment,
    canonicalUrl: `${categoryId}/`,
  };
}
